import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { DEFUALT_SELECTION_FIELD_LAYOUT } from 'widgets/FormWidget/FormWidget.config';
import { FormType, FormWidgetData, LabelPosition, SelectionFieldLayoutType } from 'widgets/FormWidget/FormWidget.types';
import { useWidget } from 'widgets/sdk';

import { LABEL_LAYOUT_OPTIONS, SELECTTION_FIELD_LAYOUT_OPTIONS } from './Layouts.config';
import { LayoutButtonProps } from './Layouts.types';

const LayoutButton = memo(({ isActive, label, icon, onClick }: LayoutButtonProps) => {
  return (
    <Button
      onClick={onClick}
      flexGrow={1}
      w={'100%'}
      h='auto'
      p={1}
      background='none'
      textAlign='center'
      transition='background 0.1s linear'
      aria-label={label}
      color={isActive ? 'upgrade.700' : 'font.500'}
      _active={{
        background: 'none',
      }}
      _hover={{
        background: isActive ? '' : 'black-alpha.200',
      }}
    >
      <Box display='flex' flexDirection='column'>
        <Box
          borderRadius='base'
          border='1px solid'
          borderColor={isActive ? 'upgrade.700' : 'gray.100'}
          bg={isActive ? '#e6f1fd' : 'none'}
        >
          {icon}
        </Box>
        <Text mt={2} fontSize='sm' fontWeight='normal' color={isActive ? 'upgrade.700' : 'font.500'}>
          {label}
        </Text>
      </Box>
    </Button>
  );
});

LayoutButton.displayName = 'LayoutButton';

const FormLabelLayout = () => {
  const { labelPosition, updateWidget } = useWidget<FormWidgetData>();

  const onSetLayout = (labelPosition: LabelPosition) => {
    updateWidget({ labelPosition });
  };

  return (
    <>
      {LABEL_LAYOUT_OPTIONS.map((layout) => {
        const onClickLayout = () => {
          onSetLayout(layout.value as LabelPosition);
        };

        return (
          <LayoutButton
            key={layout.label}
            onClick={onClickLayout}
            label={layout.label}
            icon={layout.icon}
            isActive={labelPosition === layout.value}
          />
        );
      })}
    </>
  );
};

const SelectionFieldLayout = () => {
  const { selectionFieldData, updateWidget } = useWidget<FormWidgetData>();

  const selectionFieldLayout = selectionFieldData?.layout ?? DEFUALT_SELECTION_FIELD_LAYOUT;

  const handleClick = (value: SelectionFieldLayoutType) => {
    updateWidget({ selectionFieldData: { layout: value } });
  };

  return (
    <>
      {SELECTTION_FIELD_LAYOUT_OPTIONS.map((layout) => {
        return (
          <LayoutButton
            key={layout.label}
            onClick={() => handleClick(layout.value)}
            label={layout.label}
            icon={layout.icon}
            isActive={selectionFieldLayout === layout.value}
          />
        );
      })}
    </>
  );
};

export const Layouts = () => {
  const { type } = useWidget<FormWidgetData>();
  const isSelectionField = type === FormType.SelectionField;

  return (
    <Flex px={4} gap='0.5rem' justifyContent='center'>
      {isSelectionField ? <SelectionFieldLayout /> : <FormLabelLayout />}
    </Flex>
  );
};
Layouts.displayName = 'Layouts';
